import {UserCreateModel} from '../../shared/services/user/user.create.model';
import {UserModel} from '../../shared/services/user/user.model';
import {UserPasswordModel} from '../../shared/services/user/user.password.model';
import {WebchargeStatus} from '../../shared/services/webcharge/webchargeStatus.enum';

export class GetWebcharges {
  static readonly type = '[webcharge] get webcharges';
  constructor(public page?: number, public size?: number, public reference?: string, public cardNumber?: string, public status?: WebchargeStatus) {}
}

export class GetWebchargeDetail {
  static readonly type = '[webcharge] get webcharge details';
  constructor(public reference: string) {}
}
